import { FetchMyStoreType } from '../redux/lounges/slice';
import { GET_BASE_URL } from '../constants/apiEndpoints';
import { readLoungeAuthorizedData } from '../utils/loungeAuthRefresh';

export const getAllMyHistoryApi = async ({
  sortType: _sortType,
  currentPage,
}: FetchMyStoreType) => {
  return readLoungeAuthorizedData(
    GET_BASE_URL + `/api/v1/getMyHistory?page=${currentPage}`,
    'getMyHistory'
  );
};
